module.exports = __webpack_public_path__ + "img/CS26Q-中_07.f27c63e2.jpg";